// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__TIHPx","imgContainer":"Landing_imgContainer__faRh1","image":"Landing_image__i8IP3"};